export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
/** Clamp index to be within the min/max index range. */
export function clamp(value, max) {
    return Math.max(Math.min(value, max), 0);
}
export const highlightTitleWords = (title) => title.replaceAll(/\*([\w\W]+)\*/g, '<span>$1</span>');
export const formatCurrency = (amount) => amount.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
export const getInitials = (name) => {
    const nameArray = name.split(' ');
    const firstNameIn = nameArray[0].charAt(0).toUpperCase();
    const lastNameIn = nameArray[nameArray.length - 1].charAt(0).toUpperCase();
    return firstNameIn + lastNameIn;
};
/**
 * (?=.*[a-z])        = Check for lowercase letter
 * (?=.*[A-Z])        = Check for uppercase letter
 * (?=.*[0-9])        = Check for digit
 * (?=.*[^\da-zA-Z])  = Check for non-digit and non-letter (^ negates the [] section)
 * .{8,}              = Make sure it is at least 8 characters, no maximum
 */
export const PASSWORD_RULE_REGEX = /^(?=.*[A-Z])(?=.*[\W])(?=.*[0-9])(?=.*[a-z])(?=.*[^\da-zA-Z]).{8,}$/;
/**
 * Make sure this explains PASSWORD_RULE_REGEX
 */
export const PASSWORD_RULE_MESSAGE = `Please enter a valid password`;
/**
 * Set of rules to keep the wording consistant throughout the site.
 */
export const PASSWORD_RULES = [
    'At least 8 characters long',
    'At least one Uppercase letter A-Z',
    'At least one Lowercase letter A-Z',
    'At least one base 10 digits 0-9',
    'At least one special character (~!@#$%^&*_-+=`|(){}[]:;”’<>,.?/)',
];
/**
 * Rule structure for react-hook-form
 */
export const PASSWORD_RULE = {
    message: PASSWORD_RULE_MESSAGE,
    value: PASSWORD_RULE_REGEX,
};
/**
 * Rule structure for react-hook-form
 */
export const EMAIL_RULE = {
    message: `Please enter a valid email address`,
    value: /^[\w\-.\d*]+@[\w\-\d.]+(\.\w*)$/,
};
/**
 * Rule structure for react-hook-form
 */
export const PHONE_NUMBER_RULE = {
    message: `Please enter a valid phone number`,
    value: /^[\d+()\-x ]+$/,
};
/**
 * Rule structure for full name. At least two words separated by a space
 */
export const FULL_NAME_RULE = {
    message: `Please enter a valid full name with first and last names`,
    value: /^([\w\-\u00C0-\u017F]{3,})+\s+([\w\s\-\u00C0-\u017F]{3,})+$/i,
};
/**
 * Rule structure for react-hook-form
 * Pattern based on https://andrewwburns.com/2018/04/10/uk-postcode-validation-regex/, but allows both lower and uppercase
 */
export const POSTCODE_RULE = {
    message: `Please enter a valid postcode`,
    value: /^(([A-Za-z][0-9]{1,2})|(([A-Za-z][A-HJ-Ya-hj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-HJ-Ya-hj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2}$/,
};
